import {SimpleGrid as MantineSimpleGrid} from '@mantine/core';

/**
 * Equal-width column grid — design-layer pass-through over Mantine `SimpleGrid`.
 * @registry Pass-through Mantine SimpleGrid; import this instead of @mantine/core outside src/design.
 */
export const SimpleGrid = MantineSimpleGrid;
